function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#e13416"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M10.986 15.977l8.39-6.292.028 4.106-8.39 6.292-8.475-6.178L2.511 9.8l8.475 6.178z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.958 14.228V.686M8.958 14.228V.686"
}));
function SvgDoubleArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref);
}
export default SvgDoubleArrowDown;